import { MicroFrontEnd } from 'properties-ui-common'
import { useParams } from 'react-router-dom'
import apiConfig from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const IndirectItemVariations = () => {
  const { id } = useParams<any>()
  return (
    <MicroFrontEnd
      name="IndirectItemVariations"
      src={apiConfig.microFrontEnds.IndirectItemVariations}
      props={{
        tcin: id,
      }}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}

export default IndirectItemVariations
